import styled from "styled-components";

export const Container  = styled.div `

    margin-top: 20px;

    .div-image {
        position: relative;
        max-height: max-content;
    }

    header {
        margin: 20px 0;
    }

    header::-webkit-scrollbar {
        display: none;
    }

    .section-bt-more {
        display: flex;
        justify-content: center;
        margin: 50px 0 20px 0;
    }

    .bt-more {
        background: #404040;
        border: none;
        border-radius: 50px;
        color: #fff;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 700;
        padding: 10px 40px;
        transition: all .3s ease;
    }
    
    .bt-more:hover {
        background: #505050;
    }

    .container-no-image {
        text-align: center;
        margin-top: 50px;
        width: 100%;
    }
    
    @media (max-width: 450px) {

        header {
            min-width: 100%;
            max-width: 100%;
            overflow: auto;
        }
    }
`

export const ImagesType  = styled.div `
    display: flex;

    label {
        margin-right: -5px !important;
    }

    button {
        font-size: .8rem !important;
    }
    
    @media (max-width: 800px) {
        font-size: .7rem !important;
    
        button {
            font-size: .7rem !important;
        }
    }
    
    @media (max-width: 600px) {
    
        button {
            font-size: .65rem !important;
        }
    }
`

export const Image  = styled.img `

    min-height: 180px;
    height: 100%;
    max-height: ${props => props.imagesType == 'posters' ? '300px' : '205px'};
    min-width: ${props => props.imagesType == 'backdrops'  ? '100%' : props.imagesType == 'logos' ? '100%' : props.imagesType == 'posters' ? '100%' : 'auto'} ;
    max-width: ${props => props.imagesType == 'backdrops'  ? '100%' : props.imagesType == 'logos' ? '100%' : props.imagesType == 'posters' ? '100%' : 'auto'} ;
    padding: ${props => props.imagesType == 'logos'  ? '5px' : '0'};
    object-fit: contain;
    border-radius: 3px;
    background: ${props => props.imagesType == 'logos'  ? '#303030' : 'unset'};

    @media (max-width: 1500px) {
        min-height: 150px;
        max-height: ${props => props.imagesType == 'posters' ? '300px' : '180px'};
    }

    @media (max-width: 1200px) {
        min-height: 170px;
        max-height: ${props => props.imagesType == 'posters' ? '300px' : '200px'};
    }

    @media (max-width: 800px) {
        min-height: 140px;
        max-height: ${props => props.imagesType == 'posters' ? '300px' : '130px'};
    }

    @media (max-width: 700px) {
        min-height: 120px;
    }
    
    @media (max-width: 600px) {
        min-height: ${props => props.imagesType == 'posters' ? '300px' : 'auto'};
        max-height: ${props => props.imagesType == 'posters' ? '500px' : 'max-content'};
        min-width: 100%;
        object-fit: cover;
    }

    @media (max-width: 400px) {
        max-width: 150px;
    }
`

export const Content  = styled.div `

    position: relative;
    display: grid;
    grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 5 : 8}, 1fr);
    gap: 5px;
    
    .language {
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: .8rem;
        font-weight: 600;
        border-radius: 5px;
        padding: 2px 5px;
        background: #00000090;
    }

    @media (max-width: 2000px) {
        grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 4 : 6}, 1fr);
    }

    @media (max-width: 1800px) {
        grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 3 : 6}, 1fr);
    }

    @media (max-width: 1200px) {
        grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 2 : 4}, 1fr);
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 2 : 3}, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(${props => props.imagesType != 'posters'  ? 1 : 2}, 1fr);
    }

    @media (max-width: 400px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;

  label {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }

  select {
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #007bff;
    }

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }

  option {
    padding: 8px;
    font-size: 14px;
    color: #333;
  }
`;